import { useState, useCallback } from "react";
import FilterManagement from "./FilterManagement";
import LoadingDisplay from "../../../common/LoadingDisplay/LoadingDisplay";
import BlueScrollBackToTopButton from "../../../common/BlueScrollBackToTopButton";
import "./FilterContent.css";
import PreloadProfanityFilterService from "../../../../services/PreloadService/PreloadProfanityFilterService";
import { useTranslation } from "react-i18next";
import useAsync from "../../../../services/useAsync";

const FilterContent = () => {
    const { t } = useTranslation("profanityPage");

    const [loading, setLoading] = useState(true);
    const [newFilterInput, setNewFilterInput] = useState("");
    const [createFilterMessage, setcreateFilterMessage] = useState("");
    const [filterAddButtonClass, setFilterAddButtonClass] = useState(true);

    const {
        loadProfanityFilter,
        deleteProfanityFilter,
        updateProfanityFilter,
        addFirstProfanityFilter,
        profanityFilters,
    } = PreloadProfanityFilterService();

    //makes button visibal on input
    if (newFilterInput.length > 0 && filterAddButtonClass !== false) {
        setFilterAddButtonClass(false);
    }

    const loadPage = useCallback(async () => {
        setLoading(true);

        await Promise.all([loadProfanityFilter()]);

        setLoading(false);
    }, [loadProfanityFilter]);

    useAsync(loadPage);

    const createFilter = async () => {
        if (newFilterInput) {
            setcreateFilterMessage(t("addingFilter"));

            await addFirstProfanityFilter(newFilterInput);

            setcreateFilterMessage(t("newFilterAdded"));
            setNewFilterInput("");
            setFilterAddButtonClass(true);

            setTimeout(() => setcreateFilterMessage(""), 2000);
        }
    };

    const handelKeyPress = (event) => {
        if (event.key === "Enter") {
            createFilter();
        }
    };

    if (loading) {
        return <LoadingDisplay />;
    } else {
        return (
            <div className="scrollableContainer">
                <BlueScrollBackToTopButton
                    buttonShowThreshold={1000}
                    left={true}
                />
                <FilterManagement
                    filters={profanityFilters}
                    createFilter={createFilter}
                    setNewFilterInput={setNewFilterInput}
                    loading={loading}
                    createFilterMessage={createFilterMessage}
                    filterAddButtonClass={filterAddButtonClass}
                    handelKeyPress={handelKeyPress}
                    newFilterInput={newFilterInput}
                    updateProfanityFilter={updateProfanityFilter}
                    deleteProfanityFilter={deleteProfanityFilter}
                />
            </div>
        );
    }
};

export default FilterContent;
